import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

export const managementApplicationCategory = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/application-category",
});
export const workspaceApplicationCategory = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/application-category",
});

export const applicationCategory = createCrudVuexModule({
  namespaced: true,
  path: "/library/application-category",
});
export const application = createCrudVuexModule({
  namespaced: true,
  path: "/application",
  state: { isDownloading: false },
  getters: { isDownloading: (state) => state.isDownloading },
  mutations: { isDownloading: (state, value) => (state.isDownloading = value) },
  actions: {
    async download({ commit }, payload) {
      commit("isDownloading", true);
      try {
        return await rest.post("/application/download", payload);
      } finally {
        commit("isDownloading", false);
      }
    },
    async fetchDetail({ commit }, id) {
      try {
        commit("isLoading", true);
        const response = await rest.get(`/application/${id}`);
        commit("task", response.data);

        return response.data;
      } finally {
        commit("isLoading", false);
      }
    },

    async create({ getters, commit, dispatch }, payload) {
      try {
        commit("isUpdating", true);
        payload = await dispatch("preparePayload", {
          editedEntity: getters.editedEntity,
          form: payload,
        });

        const response = await rest.post(`/application`, { item: payload });
        // commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },

    async update({ getters, commit, dispatch }, payload) {
      try {
        commit("isUpdating", true);
        payload = await dispatch("preparePayload", {
          editedEntity: getters.editedEntity,
          form: payload,
        });

        const response = await rest.put(`/application`, { item: payload });
        //  commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
  },
});
